export default {
	PASSTHROUGH_ENDPOINT: `${process.env.VUE_APP_GDS_BASE_URL}/v3/applications/:app_id/`,
	PASSTHROUGH_DEVPORTAL_ENDPOINT: `${process.env.VUE_APP_GDS_BASE_URL}/v3/applications/:app_id/v1/companies/:company_id/applications/`,
}
